import React from 'react';
import cn from '@/utils/cn';
import { SCORE_RANGES } from './actions';

const RangeLegend = () => (
  <ul className="tw-flex tw-gap-3 tw-m-0 tw-p-0 tw-list-none" role="list">
    {SCORE_RANGES.map(range => (
      <li key={range.from} className="tw-flex tw-items-center tw-gap-3.5 tw-text-sm">
        <span aria-hidden className={cn('tw-w-5 tw-h-5 tw-rounded', range.className)} />
        {`${range.from}%-${range.to}%`}
      </li>
    ))}
  </ul>
);

export default RangeLegend;
